export enum QuoteStatus {
  RESENT= 'Resent',
  SENT= 'Sent'
}
